import React from 'react';
import { Drawer, Box, IconButton } from '@mui/material';
import IconClose from '../../assets/icons/IconClose';

const RightSideDrawer = ({
  open,
  onClose,
  headerContent,
  bodyContent: BodyContent,
  footerContent,
  width = 400,
}) => {
  return (
    <Drawer
      anchor='right'
      variant='modal-rightSide'
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: (theme) => ({
          width,
        }),
      }}
    >
      <Box p={2} className='drawer-header'>
        {headerContent}

        <IconButton size='small' onClick={onClose}>
          <IconClose width={20} height={20} />
        </IconButton>
      </Box>

      <Box p={2} className='drawer-body'>
        <BodyContent />
      </Box>

      <Box p={2} className='drawer-footer'>
        {typeof footerContent === 'function' ? footerContent(onClose) : footerContent}
      </Box>
    </Drawer>
  );
};

export default RightSideDrawer;
